import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig, profile } from 'config/config'; // Importing configuration settings

/**
 * Class representing the balance history view.
 * @extends JetView
 */
export default class tableBalanceHistorysView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        var vthis = this; // Reference to the current instance

        /**
         * Marks old values with specific background colors based on their numeric value.
         * @param {number} value - The value to evaluate.
         * @param {Object} config - The configuration object.
         * @returns {Object} Style object for the row.
         */
        function mark_old(value, config) {
            var num = webix.Number.parse(value, {
                decimalSize: 2,
                groupSize: 3,
                decimalDelimiter: '.',
                groupDelimiter: ',',
            });
            if (num > 30 && num < 99) {
                return { background: 'orange' }; // Orange background for values between 30 and 99
            }
            if (num > 100) {
                return { background: 'red' }; // Red background for values greater than 100
            }
        }

        return {
            rows: [
                {
                    cols: [
                        {
                            view: 'treetable', // Treetable component
                            id: 'datatable', // Unique identifier for the datatable
                            css: 'webix_header_border webix_data_border', // CSS classes for styling
                            scheme: {
                                $change: function (item) {
                                    // Function to handle item changes
                                },
                            },
                            columns: [
                                {
                                    id: 'CreatedLocalDate', // Column ID
                                    header: _('Fecha de creación'), // Column header with localization
                                    width: 250, // Column width
                                    sort: 'int', // Sorting type
                                    template: function (obj, common) {
                                        if (obj.$group) return common.treetable(obj, common) + obj.value; // Return grouped value
                                        return obj.CreatedLocalDate; // Return creation date
                                    },
                                },
                                {
                                    id: 'Country', // Column ID
                                    header: _('País'), // Column header with localization
                                    hidden: !devConfig.getPermAction('sensitiveInformationCountry', 'Add'), // Conditional visibility based on permissions
                                    css: 'prm-filterByCountry', // CSS class for styling
                                    width: 80, // Column width
                                    sort: 'int', // Sorting type
                                    template: function (obj) {
                                        return (
                                            "<i class='flags " + obj.Country + "'></i>" // Flag icon based on country
                                        );
                                    },
                                },
                                {
                                    id: 'UserId', // Column ID
                                    header: _('ID Usuario'), // Column header with localization
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'UserName', // Column ID
                                    header: _('Nombre Usuario'), // Column header with localization
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                    hidden: !devConfig.getPermAction('sensitiveInformationNames', 'Add'), // Conditional visibility based on permissions
                                },
                                {
                                    id: 'BalanceInitial', // Column ID
                                    header: _('Saldo Inicial'), // Column header with localization
                                    width: 130, // Column width
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Formatting for price
                                    exportType: 'number', // Export type
                                },
                                {
                                    id: 'InitialRechargeQuota', // Column ID
                                    header: _('Cupo recargas inicial'), // Column header with localization
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Formatting for price
                                    exportType: 'number', // Export type
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                                {
                                    id: 'InitialGameQuota', // Column ID
                                    header: _('Cupo juego inicial'), // Column header with localization
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Formatting for price
                                    exportType: 'number', // Export type
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                                {
                                    id: 'AmountWinCasino', // Column ID
                                    header: _('Transf Apuesta E'), // Column header with localization
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Formatting for price
                                    exportType: 'number', // Export type
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                                {
                                    id: 'AmountBetsCasino', // Column ID
                                    header: _('Transf Apuesta S'), // Column header with localization
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Formatting for price
                                    exportType: 'number', // Export type
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                                {
                                    id: 'AdjustmentE', // Column ID
                                    header: _('Transf Recarga E'), // Column header with localization
                                    width: 80, // Column width
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Formatting for price
                                    exportType: 'number', // Export type
                                    footer: { content: 'summColumn' }, // Footer content
                                    hidden: true, // Hidden by default
                                },
                                {
                                    id: 'AdjustmentS', // Column ID
                                    header: _('Transf Recarga S'), // Column header with localization
                                    width: 80, // Column width
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Formatting for price
                                    exportType: 'number', // Export type
                                    footer: { content: 'summColumn' }, // Footer content
                                    hidden: true, // Hidden by default
                                },
                            ],
                            on: {
                                onBeforeLoad: function () {
                                    this.showOverlay(
                                        "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                                    ); // Show loading overlay before data load
                                },
                                onAfterLoad: function () {
                                    this.hideOverlay(); // Hide loading overlay after data load
                                },
                            },
                            ready: function () {
                                if (!this.count()) {
                                    webix.extend(this, webix.OverlayBox); // Extend with overlay functionality
                                    this.showOverlay(
                                        "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                                            _('No hay datos') +
                                            '</div>', // Show no data message
                                    );
                                }
                            },
                            footer: true, // Enable footer
                            tooltip: true, // Enable tooltips
                            math: true, // Enable math operations
                            loadahead: devConfig.getDefaultDataFetch(), // Load ahead configuration
                            pager: 'pagerA', // Pager ID
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event handlers.
     * @param {Object} grid - The grid component.
     */
    init(grid) {
        grid = $$('datatable'); // Reference to the datatable
        var url = devConfig.geturlApi() + 'es/BalanceHistory/GetBalanceHistoryAdminUser'; // API endpoint for loading data
        var filter = ''; // Filter string for API requests

        // Event handler for after data load
        grid.attachEvent('onAfterLoad', function () {
            $$('datatable').data.group({
                by: 'UserName', // Grouping by UserName
                map: {
                    UserName: ['UserName'],
                    Country: ['Country'],
                    UserId: ['UserId'],
                    BalanceInitial: ['BalanceInitial', 'sum'], // Summing BalanceInitial
                    InitialRechargeQuota: ['InitialRechargeQuota', 'sum'], // Summing InitialRechargeQuota
                    InitialGameQuota: ['InitialGameQuota', 'sum'], // Summing InitialGameQuota
                    AmountWinCasino: ['AmountWinCasino', 'sum'], // Summing AmountWinCasino
                    AmountBetsCasino: ['AmountBetsCasino', 'sum'], // Summing AmountBetsCasino
                },
            });
        });

        // Event handler for filtering data
        this.on(this.app, 'balanceHistory:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize filter string
            for (var i = 0; i < object.length; i++) {
                if (object[i][0] == 'Type') {
                    if (object[i][1] == 0) {
                        grid.showColumn('UserId', { spans: true }); // Show UserId column
                        grid.showColumn('UserName', { spans: true }); // Show UserName column
                    } else {
                        grid.hideColumn('UserId', { spans: true }); // Hide UserId column
                        grid.hideColumn('UserName', { spans: true }); // Hide UserName column
                    }
                }
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - '); // Split date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom to filter string
                        string1 = string1 + '&dateTo=' + date[1]; // Add dateTo to filter string
                    } else {
                        if (object[i][0] != 'Date') {
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters to string
                        } else {
                            if (object[i][0] == 'Date') {
                                var date = object[i][1].replace(' 00:00:00', ''); // Format date
                                string1 = string1 + '&dateFrom=' + date; // Add dateFrom to filter string
                                string1 = string1 + '&dateTo=' + date; // Add dateTo to filter string
                            }
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Convert nested filter data to entries
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Parse start date
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Add start date to filter string
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // Parse end date
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Add end date to filter string
                                    }
                                }
                            }
                        }
                    }
                }
            }
            console.log(grid); // Log the grid object
            grid.clearAll(); // Clear existing data in the grid
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load data with filters
            filter = string1; // Update filter variable
        });

        // Event handler for sorting data
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir, // Load sorted data
            );
        });

        // Event handler for item click
        grid.attachEvent('onItemClick', function (id, e, node) {
            var item = this.getItem(id); // Get clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
        });

        // Event handler for player selection
        this.on(this.app, 'player:select', (Id) => {
            grid.load(
                grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + Id, // Load data for selected player
            );
        });
    }
}

// FILE DOCUMENTED
